module.exports = "/_next/static/images/Hero-43cdcf98db02fd709dd6660f7f45084c.webp";